module.exports = __webpack_public_path__ + "fonts/dripicons-v2.7e12564e.eot";